import { createSelector } from "reselect";

export const selectSimulations = (state) => state.simulation.simulationsByCase;
export const selectCurrentCaseId = (state) => state.projects.currentCaseId;

export const selectCaseSimulationNotifications = createSelector(
  selectSimulations,
  selectCurrentCaseId,
  (simulations, caseId) => (caseId ? simulations[caseId] : [])
);